import { FC, useCallback } from 'react'
import styled from 'styled-components'
import { checkCategoryDepthAndShowWarning } from '../../module/utils'
import useJobCategoryStore from '../../store/store.jobCategory'
import { TJobCategory } from '../../type/jobCategoryStoreType'
import DrawCategoryItem, { TDrawCategoryItemInfo } from './DrawCategoryItem'

interface IFCategoryItemProps {
  category: TJobCategory
  className?: string
}

const CategoryItem: FC<IFCategoryItemProps> = ({ category, className }) => {
  const { id, name, isSelect, depth, parentId } = category

  checkCategoryDepthAndShowWarning(depth, [3])

  const selectId = useJobCategoryStore((state) => state.selectId)
  const unSelectId = useJobCategoryStore((state) => state.unSelectId)
  const idIsShowSelected = useJobCategoryStore(
    (state) => state.idIsShowSelected,
  )

  const categoryItem: TDrawCategoryItemInfo = {
    id,
    name,
    isSelect,
  }

  const handleSelectCategory = useCallback(
    (categoryItemId: string) => {
      if (isSelect) {
        return unSelectId(categoryItemId)
      }

      if (parentId) {
        const parentIsSelect = idIsShowSelected(parentId)

        // 부모(전체)가 선택되어 있다면, 부모 선택 해제
        parentIsSelect && unSelectId(parentId)
      }

      selectId(categoryItemId)
    },
    [isSelect, parentId],
  )

  return (
    <StyledWrapper
      categoryItem={categoryItem}
      onClick={handleSelectCategory}
      className={className}
    />
  )
}

export default CategoryItem

const StyledWrapper = styled(DrawCategoryItem)``
